import { Injectable } from "@angular/core";
import { GoldenLayoutServiceProfileConfig } from "../golden-layout/golden-layout-component";

@Injectable()
export class BfxOrderBlotterAuditService implements GoldenLayoutServiceProfileConfig {
  public showTransfer: boolean = false;
  public showNotification: boolean = false;
  public showRevaluations: boolean = false;
  public showTriggered: boolean = false;
  public sortField: string = null;
  public sortOrder: number = null;
  public columnConfig: any = null;
  public columnOrder: string[] = null;

  glServiceProfileConfig(): GoldenLayoutServiceProfileConfig {
    return this;
  }

  getServiceConfiguration(): object {
    return {
      showTransfer: this.showTransfer,
      showNotification: this.showNotification,
      showRevaluations: this.showRevaluations,
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      columnConfig: this.columnConfig,
      columnOrder: this.columnOrder,
      showTriggered: this.showTriggered,
    };
  }

  setServiceConfiguration(config: any): void {
    if (config != null) {
      this.showTransfer = config.showTransfer;
      this.showNotification = config.showNotification;
      this.showRevaluations = config.showRevaluations;
      this.sortField = config.sortField;
      this.sortOrder = config.sortOrder;
      this.columnConfig = config.columnConfig;
      this.columnOrder = config.columnOrder;
      this.showTriggered = config.showTriggered;
    }
  }
}
